import { jwtDecode } from 'jwt-decode';

export function isTokenExpired(token: string) {
  const decoded = jwtDecode(token);
  // exp means expiration seconds. it based on Unix epoch.
  const expirationDate = new Date((decoded.exp as number) * 1000);
  const now = new Date();
  return now.getTime() > expirationDate.getTime();
}
